import { FormControl, ValidatorFn } from '@angular/forms';

export function watchField() {
  return (formControl: FormControl) => {
    if (!formControl.parent) {
      return null;
    }

    Object.values(formControl.parent.controls).forEach(value => {
      if (value !== formControl) {
        value.updateValueAndValidity();
      }
    });

    return null;
  };
}

export function validateIf<T>(
  conditionalFieldName: string,
  conditionalValue: T | T[],
  validators: ValidatorFn | ValidatorFn[],
  nestedFieldName?: string,
  errorNamespace = 'conditional'
): ValidatorFn {
  return formControl => {
    if (!formControl.parent) {
      return null;
    }

    let error = null;
    const conditionalField = formControl.parent.get(conditionalFieldName);

    if (!conditionalField) {
      console.warn('Conditional field not found');

      return null;
    }
    if (nestedFieldName && conditionalField.value === null) {
      // Nested field name provided but conditional field is not yet filled

      return null;
    }
    if (
      Array.isArray(conditionalValue)
        ? conditionalValue.includes(
            nestedFieldName
              ? conditionalField.value[nestedFieldName]
              : conditionalField.value
          )
        : nestedFieldName
          ? conditionalField.value[nestedFieldName] === conditionalValue
          : conditionalField.value === conditionalValue
    ) {
      const validatorArr = Array.isArray(validators)
        ? validators
        : [validators];

      error = validatorArr.some(validator => validator(formControl) !== null);
    }

    if (errorNamespace && error) {
      const customError = {};
      // @ts-expect-error assigning error to a dynamic property
      customError[errorNamespace] = error;
      error = customError;
    }

    return error;
  };
}
